// extracted by mini-css-extract-plugin
module.exports = {"root":"inlineVideo_root__cCkpH"};